import request from '../request';

export const getCountries = () => request.get('countries').then((res) => res);
